// src/protocols/index.js — екран „Протоколи": табове ВОП / Общо събрание /
// Задължения / Дивиденти (Фаза 3.2).

import { el, clear, $ } from '../shared/dom.js';
import { tabBar } from '../shared/ui.js';
import { state } from '../shared/state.js';
import * as vop from './vop.js';
import * as assemblies from './assemblies.js';
import * as debts from './debts.js';
import * as dividends from './dividends.js';
import * as vnoski from './vnoski.js';

let _protoTab = 'vop';

export async function view(page) {
  clear(page);
  if (!state().activeCompany) return window.CRM.needsCompany(page);
  page.appendChild(tabBar([
    { id: 'vop', label: 'ВОП по чл. 117' }, { id: 'assembly', label: 'Общо събрание' },
    { id: 'vnoski', label: 'Допълнителни вноски' }, { id: 'debts', label: 'Справка задължения' },
    { id: 'dividends', label: 'Дивиденти' },
  ], _protoTab, (id) => { _protoTab = id; window.CRM.renderView($('#page')); }, 'Видове протоколи'));
  const area = el('div'); page.appendChild(area);
  if (_protoTab === 'dividends') return dividends.view(area);
  if (_protoTab === 'vnoski') return vnoski.view(area);
  if (_protoTab === 'debts') return debts.view(area);
  if (_protoTab === 'assembly') return assemblies.view(area);
  return vop.view(area);
}
